<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/3 m-4">
      <vx-card>
        <template #no-body>
          <div class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center bg-white">
              <div
                class="vx-col"
              >
                <div class="p-8">
                  <h4 class="text-center mb-6">
                    ただいまメンテナンス中です。
                  </h4>
                  <paragraph class="text-sm">一時サービスを停止しております。
                    ご不便をおかけいたしますが、今しばらくお待ちください。
                  </paragraph>
                </div>
              </div>
            </div>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Paragraph from '@/components/Paragraph'

export default {
  name: 'Maintenance',
  components: {
    Paragraph
  }
}
</script>
